import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import PurchaseOrderForm from './PurchaseOrderForm';
import API_URL from '../api/baseURL';
import { Page, ErrorNote } from '../components/ui/Iparc';

export default function WorkshopPurchaseOrdersPage() {
  const { token } = useAuth();
  const [suppliers, setSuppliers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/users?role=spare parts supplier`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => {
        if (!res.ok) throw new Error('Échec du chargement des fournisseurs');
        return res.json();
      })
      .then(data => setSuppliers(Array.isArray(data) ? data : []))
      .catch(err => { setSuppliers([]); setError(err.message); });
  }, [token]);

  return (
    <Page title="Bons de commande" subtitle="Documents" width="narrow">
      {error && <ErrorNote>{error}</ErrorNote>}
      <PurchaseOrderForm users={suppliers} />
    </Page>
  );
}
